import FrameSizeCalculatorHtml from './framesizecalculator.html';

class FrameSizeDirective {
    constructor() {
        this.restrict = 'E';
        this.template = FrameSizeCalculatorHtml;
        this.transclude = true;
        this.controller = FrameSizeDirectiveController;
        this.controllerAs = '$ctrl';
        this.scope = {};
    }

    static directiveFactory() {
        'ngInject';
        return new FrameSizeDirective();
    }
}

class FrameSizeDirectiveController {
    constructor($scope, SnackbarService, ProductViewService) {
        'ngInject';
        this.$scope = $scope;
        this.SnackbarService = SnackbarService;
        this.calculated = false;
        this.growth = null;
        this.innerLegLength = null;
        this.result = null;
        this.service = ProductViewService;
    }

    calculate() {
        if (!this.validate()) {
            return;
        }

        this.result = Math.floor(this.innerLegLength * 0.68);

        let frameSizes = this.service.getFrameSizes();
        let minDistance = null;
        let matchedSize = null;

        if (frameSizes) {
            frameSizes.forEach(frameSize => {
                let distance = Math.abs(frameSize - this.result);
                if (minDistance === null || minDistance > distance) {
                    minDistance = distance;
                    matchedSize = frameSize;
                }
            });
            this.result = matchedSize;
        }
        this.calculated = true;
    }

    validate() {
        if (this.growth < 50 || this.growth > 250 || this.innerLegLength < 15 || this.innerLegLength > 100) {
            this.SnackbarService.add('Nie możemy zapewnić dopasowania roweru dla podanego wzrostu i wewnętrznej długości nogi.', 'error', true, 3000);

            return false;
        }

        return true;
    }

    reset() {
        this.result = null;
        this.calculated = false;
        this.growth = null;
        this.innerLegLength = null;
    }
}

export default FrameSizeDirective;
